import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=6bb70d94&"
import script from "./popover.vue?vue&type=script&lang=ts&"
export * from "./popover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb70d94')) {
      api.createRecord('6bb70d94', component.options)
    } else {
      api.reload('6bb70d94', component.options)
    }
    module.hot.accept("./popover.vue?vue&type=template&id=6bb70d94&", function () {
      api.rerender('6bb70d94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/popover.vue"
export default component.exports